import * as React from "react";

export interface IOverlayContext {
  isActive: boolean;
  open: () => void;
  close: () => void;
}

export default React.createContext<IOverlayContext | null>(null);

export const initOverlayStore: (initialState: boolean) => IOverlayContext = initialState => {
  const [isActive, setIsActive] = React.useState(initialState);

  return {
    isActive,
    open: () => setIsActive(() => true),
    close: () => setIsActive(() => false),
  };
};
